/**
 * Copyright 2022 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import { checkUrl } from '@umati/dashboard-common';
import { SectionRowElementList } from '@umati/dashboard-types';
import SectionData from 'components/machine/sectionData';
import React, { Component, MouseEvent } from 'react';
import TemplateHelper from 'utilities/TemplateHelper';

export interface SectionElementContentListProps {
  element: SectionRowElementList;
  cols: string;
  data: any;
  label: string;
}

export interface SectionElementContentListState {
  expanded: boolean;
}

export default class SectionElementContentList extends Component<SectionElementContentListProps, SectionElementContentListState> {
  constructor (props : SectionElementContentListProps) {
    super(props);
    this.state = {
      expanded: false
    };
    this.changeExpanded = this.changeExpanded.bind(this);
  }

  changeExpanded (event: MouseEvent<HTMLElement>, isExpanded: boolean) {
    this.setState({ expanded: isExpanded });
    event.preventDefault();
  }

  render () {
    const array = TemplateHelper.getVariableValueAray(this.props.data, this.props.element.valueVariable);
    const displaySize = this.state.expanded ? array.length : 3;
    const hiddenSize = array.length - displaySize;
    return (
      <SectionData cols={this.props.cols}
        label={this.props.label}>
        {array.length < 1 &&
          'Undefined'
        }
        <ol className="value list-numbered">
          {array.slice(0, displaySize).map((arrayValue, arrayValueIndex) =>(
            <>
              {(this.props.element as SectionRowElementList).showAsLink && checkUrl(arrayValue)
                ? <li key={arrayValueIndex}><a href={arrayValue}>{arrayValue}</a></li>
                : <li key={arrayValueIndex}>{arrayValue}</li>
              }
            </>
          ))}
        </ol>
        {hiddenSize > 0 &&
          <span className="value">
            <a href="#" onClick={(e: MouseEvent<HTMLElement>) => this.changeExpanded(e, true)}>show more ({hiddenSize})</a>
          </span>
        }
        {displaySize > 3 &&
          <span className="value">
            <a href="#" onClick={(e: MouseEvent<HTMLElement>) => this.changeExpanded(e, false)}>show less</a>
          </span>
        }
      </SectionData>
    );
  }
}
